import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useCommonData } from '@/hooks';

/**
 * 判断指针是否“逻辑上位于目标区域内”
 * - 不依赖几何 rect
 * - 支持子节点视觉溢出（如下拉框 / popover）
 */
export function usePointerInElement(elRef) {
	const isInside = ref(false);
	const { viewInIframe } = useCommonData();

	const onMove = e => {
		const el = elRef.value;
		if (!el) return;

		const target = e.target;
		// 使用 contains 语义判断“逻辑归属”
		isInside.value = el === target || el.contains(target);
	};

	onMounted(() => {
		if (viewInIframe.value) return;
		window.addEventListener('mousemove', onMove, { passive: true });
	});

	onBeforeUnmount(() => {
		if (viewInIframe.value) return;
		window.removeEventListener('mousemove', onMove);
	});

	return {
		isInside
	};
}
